/**
 * Save local mínimo (M1). O save na nuvem (perfil por código-amigável) chega no M3;
 * aqui o Luar acumula em localStorage como "Luar de Sonho" (doc 06 A1: solo offline).
 */
const KEY = 'rabbit2:luar';

export function totalLuar(): number {
  try {
    return Number(localStorage.getItem(KEY) ?? '0') || 0;
  } catch {
    return 0;
  }
}

export function addLuar(delta: number): number {
  const novo = totalLuar() + Math.max(0, Math.floor(delta));
  try {
    localStorage.setItem(KEY, String(novo));
  } catch {
    /* modo privado/headless — ignora */
  }
  return novo;
}
